import { EiffelTowerIcon } from './EiffelTowerIcon';

/**
 * author: Nicolas Gres
 * id 2E11359F-82B1-469C-9A51-F7B0EFAA3171
 * name eiffel-tower
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/eiffel-tower.svg
 * tags
 * - Places 
 */
export const ParisIcon = EiffelTowerIcon;
export default ParisIcon